import React, { useEffect, useState, useCallback } from 'react'
import '../components/css/prouct.css';
import ff from '../components/images/Product Page top banner.jpg';
import { Search, Grid3x3, List, ChevronDown } from "lucide-react"
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { getActiveProducts } from '../App/Slices/productSlice';
import { useNavigate } from 'react-router-dom';

const Products = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate(); // ✅ navigation hook

  const SearchParams = new URLSearchParams(window.location.search);
  const divisionFromURL = SearchParams.get('division');
  const domainFromURL = SearchParams.get('domain');
  const speciesFromURL = SearchParams.get('species');
  const category = SearchParams.get('category');
  const [selectedDivision, setSelectedDivision] = useState(divisionFromURL ?? '')
  const [searchQuery, setSearchQuery] = useState("")
  const [domain, setDomain] = useState(domainFromURL ?? 'Domain')
  const [suitable, setSuitable] = useState(speciesFromURL ?? "Suitable for")
  const [viewMode, setViewMode] = useState("grid")
  const [showDomainDropdown, setShowDomainDropdown] = useState(false)
  const [showSuitableDropdown, setShowSuitableDropdown] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [species, setSetSpecies] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [allProducts, setAllProducts] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const domainOptions = [
    "Cardiac Care",
    "Renal Care",
    "Skin Care",
    "Ear Cleansing",
    "Endocrine Disorder",
    "Urinary Support",
    "Anti-Emetic",
    "Anti-Parasitic",
    "Liver Care",
    "Immunity & Vitamins",
    "Digestive Health",
    "Anesthetic",
    "Antibiotics",
    "Pain & Inflammation",
    "Joint Care / Bone Health",
    "Feed Supplements",
    "Emergency Medicine",
    "Others"
  ];

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${baseUrl}/get_categories.php`);
        const text = await response.text();
        const data = JSON.parse(text);
        setSetSpecies(data);
      } catch (err) {
        console.error("Error parsing species:", err.message);
        setError("Failed to fetch or parse species.");
      }
    };

    const fetchData = async () => {
      await fetchCategories();
      setLoading(false);
    };

    fetchData();
  }, []);

  const PRODUCTS_PER_PAGE = 12

  const handleReset = () => {
    setSearchQuery("")
    setDomain("Domain")
    setSuitable("Suitable for")
    setCurrentPage(1) // Reset to first page
  }

  const getPaginationNumbers = () => {
    const pages = []
    const maxPagesToShow = 3
    const sidePages = 1

    // Always show first page
    pages.push(1)

    // Add pages around current page
    if (currentPage > sidePages + 2) {
      pages.push("...")
    }

    for (let i = Math.max(2, currentPage - sidePages); i <= Math.min(totalPages - 1, currentPage + sidePages); i++) {
      if (!pages.includes(i)) {
        pages.push(i)
      }
    }

    // Add ellipsis before last page if needed
    if (currentPage < totalPages - sidePages - 2) {
      pages.push("...")
    }

    // Always show last page if there's more than 1
    if (totalPages > 1 && !pages.includes(totalPages)) {
      pages.push(totalPages)
    }

    return pages
  }

  // Optional: Dynamic title/description per division
  const divisionMeta = {
    Orion: {
      title: "Orion Division - Biological & Diagnostics",
      description: "Explore Orion Division products: Biological & Diagnostics solutions for your needs."
    },
    Regal: {
      title: "Regal Division - Innovative Therapeutic Solutions",
      description: "Explore Regal Division products: Innovative Therapeutic Solutions."
    },
    Iris: {
      title: "Iris Division - Global Nutraceuticals",
      description: "Explore Iris Division products: Global Nutraceuticals for better health."
    }
  };
  const { title, description } = divisionMeta[selectedDivision] || {};

  // JSON-LD structured data for products
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": selectedDivision,
    "description": description,
    "image": ff,
    "brand": {
      "@type": "Organization",
      "name": "Panav Biotech"
    }
  };

  // Fetch products function
  const fetchProducts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await dispatch(getActiveProducts({
        division: selectedDivision,
        species: suitable === "Suitable for" ? "" : suitable,
        category: category,
        domains: domain === 'Domain' ? "" : domain,
        showin_home: "",
        page: currentPage,
        limit: PRODUCTS_PER_PAGE,
        search: searchQuery
      }));


      if (response?.payload?.status === 'success') {
        setAllProducts(response?.payload?.data || []);
        setTotalProducts(Number(response?.payload?.total_records) || 0);
        setTotalPages(Number(response?.payload?.total_pages) || 0);
      } else {
        setAllProducts([]);
        setTotalProducts(0);
        setTotalPages(0);
      }
    } catch (err) {
      console.error("Error fetching products:", err);
      setError("Failed to fetch products. Please try again.");
      setAllProducts([]);
      setTotalProducts(0);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };

  // Fetch products when page changes
  useEffect(() => {
    fetchProducts();
  }, [currentPage]);

  // Reset to page 1 and fetch when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedDivision, suitable, domain, searchQuery]);

  // Fetch when we reset to page 1 due to filter changes
  useEffect(() => {
    if (currentPage === 1) {
      fetchProducts();
    }
  }, [currentPage, selectedDivision, suitable, domain, searchQuery]);
console.log(allProducts, "all products data in product page") // Debugging log
  return (
    <>
      {/* Helmet for SEO */}
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ff} />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <div className="min-h-screen bg-white" style={{ fontFamily: "Poppins" }}>
        {/* Header Section */}
        <div className="bg-[#003781]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
            <h1 className="text-4xl sm:text-5xl font-light text-white mb-8" style={{ fontFamily: "Poppins" }}>Products</h1>

            {/* Filters Row */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              {/* Search Input */}
              <div className="flex-1 min-w-0">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Cardiac care, Antibiotics..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full px-4 py-3 pr-10 text-gray-700 placeholder-gray-400 bg-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" />
                </div>
              </div>

              {/* Domain Dropdown */}
              <div className="sm:w-40">
                <div className="relative">
                  <button
                    onClick={() => {
                      setShowDomainDropdown(!showDomainDropdown)
                      setShowSuitableDropdown(false)
                    }}
                    className="w-full px-4 py-3 text-left text-gray-700 bg-white rounded flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <span>{domain}</span>
                    <ChevronDown className="w-4 h-4" />
                  </button>
                  {showDomainDropdown && (
                    <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded shadow-lg z-10 max-h-60 overflow-y-auto">
                      {domainOptions.map((option) => (
                        <button
                          key={option}
                          onClick={() => {
                            setDomain(option)
                            setShowDomainDropdown(false)
                          }}
                          className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100 first:rounded-t last:rounded-b"
                        >
                          {option}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Suitable For Dropdown */}
              <div className="sm:w-40">
                <div className="relative">
                  <button
                    onClick={() => {
                      setShowSuitableDropdown(!showSuitableDropdown)
                      setShowDomainDropdown(false)
                    }}
                    className="w-full px-4 py-3 text-left text-gray-700 bg-white rounded flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <span>{suitable}</span>
                    <ChevronDown className="w-4 h-4" />
                  </button>
                  {showSuitableDropdown && (
                    <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded shadow-lg z-10 max-h-60 overflow-y-auto">
                      {species.map((option) => (
                        <button
                          key={option?.id}
                          onClick={() => {
                            setSuitable(option?.name)
                            setShowSuitableDropdown(false)
                          }}
                          className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100 first:rounded-t last:rounded-b"
                        >
                          {option?.name}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Reset Link */}
              <div className="hidden sm:flex items-center">
                <button
                  onClick={handleReset}
                  className="text-white hover:text-blue-100 font-medium text-sm transition-colors whitespace-nowrap"
                  style={{ fontFamily: "Poppins" }}
                >
                  Reset
                </button>
              </div>
            </div>

            {/* Reset Button for Mobile */}
            <div className="sm:hidden mt-3">
              <button
                onClick={handleReset}
                className="w-full text-white hover:text-blue-100 font-medium text-sm transition-colors py-2"
                style={{ fontFamily: "Poppins" }}
              >
                Reset
              </button>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 text-sm text-gray-600 mb-8">
            <a href="/" className="hover:text-gray-900 transition-colors" style={{ fontFamily: "Poppins" }}>
              Home
            </a>
            <span>•</span>
            <span className="text-gray-900 font-medium" style={{ fontFamily: "Poppins" }}>Products</span>
          </div>

          {/* Products Header */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
            <h2 className="text-2xl sm:text-3xl font-semibold text-[#003781]" style={{ fontFamily: "Poppins" }}>
              {loading ? "Loading..." : `${totalProducts} Products`}
            </h2>

            {/* View Toggle */}
            <div className="flex items-center gap-2">
              <button
                onClick={() => setViewMode("grid")}
                className={`p-2 rounded transition-colors ${viewMode === "grid" ? "bg-blue-100 text-blue-600" : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  }`}
                aria-label="Grid view"
              >
                <Grid3x3 className="w-5 h-5" />
              </button>
              <button
                onClick={() => setViewMode("list")}
                className={`p-2 rounded transition-colors ${viewMode === "list" ? "bg-blue-100 text-blue-600" : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  }`}
                aria-label="List view"
              >
                <List className="w-5 h-5" />
              </button>
            </div>
          </div>

          {/* Loading State */}
          {loading && (
            <div className="text-center py-12">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#003781]"></div>
              <p className="mt-4 text-gray-600" style={{ fontFamily: "Poppins" }}>Loading products...</p>
            </div>
          )}

          {/* No Products */}
          {!loading && allProducts.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-600 text-lg" style={{ fontFamily: "Poppins" }}>No products found matching your criteria.</p>
            </div>
          )}

          {/* Products Grid/List */}
          {!loading && allProducts.length > 0 && (
            <div
              className={
                viewMode === "grid" ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" : "space-y-4 mb-12"
              }
            >
              {allProducts?.map((item, i) => (
              
                <div
                  key={item?.id || i}
                  className={`bg-white border border-gray-200 rounded overflow-hidden hover:shadow-md transition-shadow ${viewMode === "list" ? "flex items-center" : ""
                    }`}
                >
                  <div
                    className={`overflow-hidden ${viewMode === "list" ? "w-24 h-24 flex-shrink-0 mr-4" : "h-48 w-full"
                      }`}
                  >
                    <div
                      className="w-full h-full transition-transform duration-300 ease-in-out hover:scale-110"
                      style={{
                        backgroundImage: item?.image ? `url(${encodeURI(`${baseUrl}/${item?.image}`)})` : 'none',
                        backgroundSize: 'contain',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                      }}
                    >
                    </div>
                  </div>
                  <div className={viewMode === "list" ? "flex-1" : "p-4"}>
                    <h3 className="font-semibold text-gray-900 mb-2 text-center" style={{ fontFamily: "Poppins" }}>
                      {item?.title}
                    </h3>
                    {viewMode === "grid" && (
                      <button onClick={() => navigate(`${`/product-details/${item?.slug}`}`)} className="w-full px-4 py-2 bg-[#003781] rounded font-medium hover:bg-blue-700 transition-colors text-white" style={{ fontFamily: "Poppins" }}>
                        View Details
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Pagination - Only show if there are products */}
          {!loading && allProducts.length > 0 && totalPages > 1 && (
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 overflow-x-auto pb-4">
              {/* First Page */}
              <button
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
                className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 disabled:text-gray-400 disabled:cursor-not-allowed transition-colors whitespace-nowrap" style={{ fontFamily: "Poppins" }}
              >
                « First
              </button>

              {/* Previous */}
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 disabled:text-gray-400 disabled:cursor-not-allowed transition-colors whitespace-nowrap" style={{ fontFamily: "Poppins" }}
              >
                ‹ Previous
              </button>

              {/* Page Numbers */}
              <div className="flex items-center gap-1">
                {getPaginationNumbers().map((page, idx) => (
                  <div key={idx}>
                    {typeof page === "string" ? (
                      <span className="px-2 py-2 text-sm text-gray-400">...</span>
                    ) : (
                      <button
                        onClick={() => setCurrentPage(page)}
                        className={`w-9 h-9 flex items-center justify-center rounded-full text-sm font-medium transition-colors ${page === currentPage ? "bg-[#003781] text-white" : "text-gray-700 hover:bg-gray-100"
                          }`}
                      >
                        {page}
                      </button>
                    )}
                  </div>
                ))}
              </div>

              {/* Next */}
              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 disabled:text-gray-400 disabled:cursor-not-allowed transition-colors whitespace-nowrap" style={{ fontFamily: "Poppins" }}
              >
                Next ›
              </button>

              {/* Last Page */}
              <button
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
                className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 disabled:text-gray-400 disabled:cursor-not-allowed transition-colors whitespace-nowrap" style={{ fontFamily: "Poppins" }}
              >
                Last »
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default Products